export class Message {
    constructor(public text: string, public context = {}) {}
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/model/message.ts